import $ from 'jquery/dist/jquery.min';

global.jQuery = $;
